import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  padding:60px 0;
  background-size:cover;
  background-position:center;
  position:relative;
  &::before {
    content:'';
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    opacity:.5;
    background: ${colors.brand1};
  }
  .container {
    position:relative;
    z-index:1;
  }
  .headline {
    color: ${colors.white};
    font: 700 30px/1 ${typography.SansSerif};
    text-align:center;
    margin:0 0 40px 0;
    @media (min-width: 991px) {
      font: 700 42px/1 ${typography.SansSerif};
    }
  }
  .shortsList {
    display:flex;
    flex-flow:row wrap;
    justify-content:center;
  }
  .short {
    width:100%;
    display:flex;
    flex-flow:row nowrap;
    justify-content:flex-start;
    padding:20px;
    @media (min-width: 991px) {
      width:33%;
    }
  }
  .shortIcon {

  }
  .shortShort {
    color: ${colors.white};
    margin:0 0 0 20px;
  }
  .shortShort_heading {
    font: 700 24px/1 ${typography.SansSerif};
  }
  .shortShort_textArea {
    font: 400 18px/1.3 ${typography.SansSerif};
  }
  .btn-wrapper {
    text-align: center;
    width:100%;
  }
`;


function IconShorts({ page }) {
  return (
    <div className={styles} style={{ backgroundImage: `url(${buildThumbnailUrl(get(page, 'icon_shorts[0].background_image.contentUrl'), { width: 2000, height: 2000, preserve: true })})` }}>
      <div className="container">
        <h3 className="headline">{get(page, 'icon_shorts[0].headline')}</h3>
        <ul className="list-unstyled shortsList">
          {
            get(page, 'icon_shorts[0].shorts').map(item => (
              <li className="short">
                <div className="shortIcon">
                  <Image
                    src={get(item, 'icon.contentUrl')}
                    alt={get(item, 'icon.caption')}
                    width={60}
                    height={60}
                    preserve
                  />
                </div>
                <div className="shortShort">
                  <h4 className="shortShort_heading">{get(item, 'heading')}</h4>
                  <p className="shortShort_textArea" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text_area').split('\n').join('<br />'))} />
                </div>
              </li>
            ))
          }
        </ul>
        <div className="btn-wrapper">
          <Link name="about-us" hash="#energy" className="btn">Learn More</Link>
        </div>
      </div>
    </div>
  );
}

IconShorts.propTypes = {
  page: PropTypes.string,
};

IconShorts.defaultProps = {
  page: undefined,
};

export default IconShorts;



// WEBPACK FOOTER //
// ./src/components/IconShorts.js